import React from "react";
import NavBar from "../components/NavBar";
import ListingForm from "../components/ListingForm";
import Footer from "../components/Footer";
import CustomerRating from "../components/CustomerRating";

const PostProperty = () => {
    return(
        <div>
            <NavBar/>
            <ListingForm/>
            <CustomerRating/>
            <Footer/>
        </div>
    )
}

export default PostProperty;